import styled from 'styled-components';
import { ModalBody, ModalHeader } from 'components/Modal';

export const StyledModalBody = styled(ModalBody)`
  padding-bottom: 40px;
`;

export const StyledModalHeader = styled(ModalHeader)`
  padding-top: 30px;
`;

export const StyledShortcuts = styled.div`
  column-gap: 20px;
  column-width: 300px;
`;
